<template>
  <div class="search-actions">
    <div class="search-dropdown-container">
      <div
        class="search-dropdown"
        @click="opened = !opened"
        :class="{ opened }"
      >
        <div class="search-icon">
          <img src="@/assets/images/checklist.svg" alt="Search Icon" />
        </div>

        <p>Select survey questions to display in report</p>

        <div class="search-chev">
          <div class="chev-down"></div>
        </div>
      </div>

      <div class="search-dropdown-contents" v-if="opened">
        <div class="overflow-container scrollbar">
          <div
              v-for="option in options"
              :key="option.key"
              @click="toggleOption(option.key)"
              :class="{ toggled: toggled.includes(option.key) }"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
    </div>

    <button class="btn-clear" @click="clear">
      <img src="@/assets/images/btn-clear.svg" alt="Clear">
      clear
    </button>
    
    <button class="btn-select-all" @click="selectAll">
      <img src="@/assets/images/btn-ok.svg" alt="Ok">
      select all
    </button>
  </div>
</template>

<script>
export default {
  name: 'SearchDropdown',

  props: {
    options: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      opened: false,
      toggled: [],
    };
  },

  methods: {
    toggleOption(k) {
      const index = this.toggled.findIndex(i => i === k);

      if (index >= 0) {
        // Remove this item from the list.
        this.toggled.splice(index, 1);
      } else {
        this.toggled.push(k);
      }

      this.$emit('input', this.toggled);
    },

    clear() {
      this.toggled = [];
      this.$emit('input', this.toggled);
    },

    selectAll() {
      this.toggled = this.options.map(o => o.key);
      this.$emit('input', this.toggled);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-dropdown {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 1000px;
  cursor: pointer;

  .search-icon {
    position: relative;
    background: transparent linear-gradient(95deg, #ed1979 0%, #cb03a4 100%);
    border-radius: 100%;
    width: 29px;
    height: 29px;
    margin: 3px 15px 3px 3px;

    img {
      position: absolute;
      top: 50%;
      left: 57%;
      transform: translate(-50%, -50%);
      width: 50%;
    }
  }

  p {
    font-size: 15px;
    margin: 0;
  }

  .search-chev {
    position: relative;
    background-color: #ed1e7a;
    width: 35px;
    height: 35px;
    border-radius: 1000px 1000px 1000px 0;
    margin-left: auto;
  }

  &.opened {
    .search-chev .chev-down {
      transform: translate(-50%, -50%) rotateZ(180deg);
    }
  }
}

.search-actions {
  display: flex;

  .search-dropdown-container {
    flex: 1;
  }

  button {
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 6px #00000029;
    font-size: 13px;
    border: none;
    border-radius: 18px;
    padding: 10px;
    margin: 0 6px;
    width: 115px;
    font-weight: bold;
    cursor: pointer;

    img {
      height: 20px;
      margin-right: 15px;
    }
  }

  .btn-clear {
    background-color: #ffffff;
    color: #ed1979;
  }

  .btn-select-all {
    background-color: #ed1979;
    color: white;
  }
}

.scrollbar {
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 7px;
    background-color: #E4F2F2;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #5ABBD8;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #F5F5F5;
  }
}

.search-dropdown-container {
  position: relative;
  z-index: 9999999;

  .search-dropdown-contents {
    position: absolute;
    top: 17px;
    z-index: -1;
    background: white;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 0 0 16px 16px;
    padding: 26px 15px 15px 0;

    .overflow-container {
      max-height: 450px;
      overflow-y: auto;

      > div {
        margin: 0 15px 0 25px;
        padding: 10px 0;
        font-size: 15px;
        cursor: pointer;

        &:not(:last-of-type) {
          border-bottom: 1px solid #EC1D7A;
        }

        &.toggled {
          background-color: #ececec;
        }
      }
    }
  }
}
</style>
